<template>
	<div>
		<div class="topo">
			<div class="logo">
				<img :src="logo" />
			</div>
			<div class="qr">
				<qr-code
					:text="`http://patrimonio.${empresa_id == 1 ? 'geotecconsultoria.com' : 'brk.eng'}.br/ver/${patrimonio}`"
					:size="150"></qr-code>
				<div class="patrimonio">
					Patrimonio {{ patrimonio }}
				</div>
			</div>
		</div>
		<div class="equipamentos">
			<div class="equipamentos-fotos">
				<swiper class="swiper" :options="swiperOption">
					<swiper-slide v-if="equipamentos.fotos">
						<img class="equipamentos-foto img-thumbnail" :src="equipamentos.fotos" />
					</swiper-slide>
					<swiper-slide v-if="equipamentos.fotos1">
						<img class="equipamentos-foto img-thumbnail" :src="equipamentos.fotos1" />
					</swiper-slide>
					<swiper-slide v-if="equipamentos.fotos2">
						<img class="equipamentos-foto img-thumbnail" :src="equipamentos.fotos2" />
					</swiper-slide>
					<div class="swiper-pagination" slot="pagination"></div>
				</swiper>
			</div>
			<div class="equipamentos-content">
				<table class="table table-hover table-striped table-bordered">
					<tbody>
						<tr v-if="equipamentos.equipamento">
							<td>Equipamento:</td>
							<td>{{ equipamentos.equipamento }}</td>
						</tr>
						<tr v-if="equipamentos.modelo">
							<td>Modelo:</td>
							<td>{{ equipamentos.modelo }}</td>
						</tr>
						<tr v-if="equipamentos.marca">
							<td>Marca:</td>
							<td>{{ equipamentos.marca }}</td>
						</tr>
						<tr v-if="equipamentos.referencia">
							<td>Nº de Série:</td>
							<td>{{ equipamentos.referencia }}</td>
						</tr>
						<tr v-if="equipamentos.voltagem_nome">
							<td>Voltagem:</td>
							<td>{{ equipamentos.voltagem_nome }}</td>
						</tr>
						<tr v-if="equipamentos.fornecedor">
							<td>Fornecedor:</td>
							<td>{{ equipamentos.fornecedor }}</td>
						</tr>
						<tr v-if="equipamentos.valor_compra">
							<td>Valor da compra (R$):</td>
							<td>{{ equipamentos.valor_compra }}</td>
						</tr>
						<tr v-if="equipamentos.valor_locacao">
							<td>Valor da locação (R$):</td>
							<td>{{ equipamentos.valor_locacao }}</td>
						</tr>
						<tr v-if="equipamentos.nota_fiscal">
							<td>Nº nota fiscal:</td>
							<td>{{ equipamentos.nota_fiscal }}</td>
						</tr>
						<tr v-if="equipamentos.aquisicao">
							<td>Data aquisição:</td>
							<td>{{ equipamentos.aquisicao }}</td>
						</tr>
					</tbody>
				</table>
				<div
					v-if="equipamentos.situacao_af || equipamentos.ultima_af || equipamentos.proxima_af || equipamentos.verificacao || equipamentos.prox_verificacao">
					<legend>Aferição</legend>
					<table class="table table-hover table-striped table-bordered">
						<tbody>
							<tr v-if="equipamentos.situacao_af">
								<td>Situação da aferição:</td>
								<td>{{ equipamentos.situacao_af }}</td>
							</tr>
							<tr v-if="equipamentos.ultima_af">
								<td>Última aferição:</td>
								<td>{{ equipamentos.ultima_af }}</td>
							</tr>
							<tr v-if="equipamentos.proxima_af">
								<td>Próxima aferição:</td>
								<td>{{ equipamentos.proxima_af }}</td>
							</tr>
							<tr v-if="equipamentos.verificacao">
								<td>Verificação:</td>
								<td>{{ equipamentos.verificacao }}</td>
							</tr>
							<tr v-if="equipamentos.prox_verificacao">
								<td>Próxima verificação:</td>
								<td>{{ equipamentos.prox_verificacao }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="equipamentos.cal_data || equipamentos.cal_laudo || equipamentos.cal_link">
					<legend>Calibrações</legend>
					<table class="table table-hover table-striped table-bordered">
						<tbody>
							<tr v-if="equipamentos.cal_data">
								<td>Data:</td>
								<td>{{ equipamentos.cal_data }}</td>
							</tr>
							<tr v-if="equipamentos.cal_laudo">
								<td>Número do laudo:</td>
								<td>{{ equipamentos.cal_laudo }}</td>
							</tr>
							<tr v-if="equipamentos.cal_link">
								<td>Link Laudo:</td>
								<td><a :href="equipamentos.cal_link" target="_black" class="btn btn-primary">Abrir</a></td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="equipamentos.status_situacao || equipamentos.status_nome">
					<legend>Status</legend>
					<table class="table table-hover table-striped table-bordered">
						<tbody>
							<tr v-if="equipamentos.status_situacao">
								<td>Situação do equipamento:</td>
								<td>{{ equipamentos.status_situacao }}</td>
							</tr>
							<tr v-if="equipamentos.status_nome">
								<td>Condições:</td>
								<td>{{ equipamentos.status_nome }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="equipamentos.obs">
					<legend>Observações </legend>
					<table class="table table-hover table-striped table-bordered">
						<tbody>
							<tr>
								<td>Observação:</td>
								<td>{{ equipamentos.obs }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="equipamentos.cidade || equipamentos.obra">
					<legend>Localização</legend>
					<table class="table table-hover table-striped table-bordered">
						<tbody>
							<tr v-if="equipamentos.cidade">
								<td>Cidade:</td>
								<td>{{ equipamentos.cidade }}</td>
							</tr>
							<tr v-if="equipamentos.obra">
								<td>Obra:</td>
								<td>{{ equipamentos.obra }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import req from '@/components/request'
import QrCode from 'vue-qr-generator'
import moment from 'moment'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
	components: {
		QrCode,
		Swiper,
		SwiperSlide
	},
	data: () => ({
		patrimonio: null,
		domain: null,
		empresa_id: 0,
		equipamentos: {},
		logo: '',
		swiperOption: {
			pagination: {
				el: '.swiper-pagination'
			}
		}
	}),
	methods: {
		async getEmpresa() {
			const domain = window.location.host
			if (this.empresa_id) {
				if(this.empresa_id == 1) {
					this.logo = require('@/assets/geotec-logo.png')
				}
				if(this.empresa_id == 2) {
					this.logo = require('@/assets/brk-logo.png')
				}
				if(this.empresa_id == 3) {
					this.logo = require('@/assets/brgeo-logo.png')
				}
				return this.getEquipamento()
			}
			if (domain.match(/.+\.(.+\..{0,3}\..{0,2}$)/)) {
				const dados = await req(`/empresas/domain/${domain.match(/.+\.(.+\..{0,3}\..{0,2}$)/)[1]}`)
				this.empresa_id = dados.id
				if(dados.id == 1) {
					this.logo = require('@/assets/geotec-logo.png')
				}
				if(dados.id == 2) {
					this.logo = require('@/assets/brk-logo.png')
				}
				if(dados.id == 3) {
					this.logo = require('@/assets/brgeo-logo.png')
				}
				return this.getEquipamento()
			}
		},
		async getEquipamento() {
			const dados = await req(`/equipamentos/patrimonio/${this.patrimonio}/${this.empresa_id}/all`)
			if (dados.valor_compra == 'NaN') {
				dados.valor_compra = ''
			}
			if (dados.valor_locacao == 'NaN') {
				dados.valor_locacao = ''
			}
			dados.valor_compra = dados.valor_compra ? dados.valor_compra : ''
			dados.valor_locacao = dados.valor_locacao ? dados.valor_locacao : ''
			dados.cal_data = dados.cal_data ? moment(dados.cal_data).format('DD/MM/YYYY') : ''
			dados.ultima_af = dados.ultima_af ? moment(dados.ultima_af).format('DD/MM/YYYY') : ''
			dados.proxima_af = dados.proxima_af ? moment(dados.proxima_af).format('DD/MM/YYYY') : ''
			dados.prox_verificacao = dados.prox_verificacao ? moment(dados.prox_verificacao).format('DD/MM/YYYY') : ''
			this.equipamentos = dados
		}
	},
	mounted() {
		this.patrimonio = this.$route.params.id
		this.empresa_id = this.$route.params.empresa || 0
		this.getEmpresa()
	},
}
</script>

<style lang="stylus" scoped>
.topo {
	display: flex;
	justify-content: space-between;
	.patrimonio {
		font-size: 18px;
		font-weight: bold;
    display: flex;
    justify-content: center;
	}
	.qr {
		display: flex;
    justify-content: center;
		flex-direction: column;
		align-items: center;
	}
}

.equipamentos {
	display: flex;
	&-foto {
		width: 180px;
	}
	&-content {
		flex: 1;
		margin-left: 10px
	}
}

.swiper {
	width: 180px;
  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
  }
}

	@media only screen and (max-width: 600px) {
.equipamentos {
	flex-direction: column;
	&-foto {
		width: 100%;
		margin-bottom: 10px;
	}
	&-content {
		flex: 1;
		margin-left: 10px
	}
}

.swiper {
	width: 100%;
}

.topo {
	flex-direction: column;
	margin-bottom: 10px;
	.logo {
		display: flex;
		justify-content: center;
	}
}
	.table-responsive {
		border: 0 !important;
	}
}


</style>